import { action, mutator, orchestrator } from 'satcheljs';
import getAppHostStore from '../store/appHostStore';
import { log } from '../utils/telemetry';
import type AppHostViewState from '../store/schema/AppHostViewState';
import type { MailboxInfo } from 'owa-client-types';

export type OpenMetaOsAppAction = {
    viewState: AppHostViewState;
    mailboxInfo?: MailboxInfo;
};

/* Do not call this action directly, use utils/openLaunchPageMetaOsApp instead */
export interface OnOpenMetaOsAppActionMessage {
    viewState: AppHostViewState;
    mailboxInfo: MailboxInfo | undefined;
}
const onOpenMetaOsApp: ({
    viewState,
    mailboxInfo,
}: OpenMetaOsAppAction) => OnOpenMetaOsAppActionMessage = action(
    'onOpenMetaOsApp',
    ({ viewState, mailboxInfo }: OpenMetaOsAppAction): OnOpenMetaOsAppActionMessage => ({
        viewState,
        mailboxInfo,
    })
);

mutator(onOpenMetaOsApp, (actionMessage: OpenMetaOsAppAction) => {
    let { viewState } = actionMessage;

    // save viewstate to store
    getAppHostStore().viewStates.set(viewState.appHostId, viewState);
    viewState = getAppHostStore().viewStates.get(viewState.appHostId) ?? viewState;

    // save primary app host id to store
    getAppHostStore().primaryAppHostId = viewState.appHostId;

    const { appDefinition } = viewState;
    if (!appDefinition || !appDefinition.staticTabs || appDefinition.staticTabs.length === 0) {
        viewState.isInError = true;
    }
});

orchestrator(onOpenMetaOsApp, actionMessage => {
    const { viewState } = actionMessage;
    const { appDefinition, callerFn, entityId, subEntityId, subEntityLabel } = viewState;
    const logData = {
        callerFn,
        entityId,
        subEntityId,
        subEntityLabel,
        appId: appDefinition?.id ?? '',
        appName: appDefinition?.name ?? '',
        appStaticTabs: JSON.stringify(appDefinition?.staticTabs),
    };
    log(logData);
});

export default onOpenMetaOsApp;
